module.exports = __webpack_public_path__ + "img/michael.b__600x600.3df7f95f.jpg";